import { render, staticRenderFns } from "./entity-cross-reference.vue?vue&type=template&id=52a528f2&"
import script from "./entity-cross-reference.vue?vue&type=script&lang=js&"
export * from "./entity-cross-reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports